import { APP_URLS, PLATFORM_TYPE } from "../app/constants/constants";
import ENV from "../app/constants/env"
import getObjectCommand from "../app/constants/utils";

const { PING_BUCKETNAME, PING_FILE_NAME } = ENV;

const isStandaloneMode: boolean = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;

const checkPlatform = () => {
    const { userAgent } = navigator
    if (/android/i.test(userAgent)) {
        return PLATFORM_TYPE.ANDROID;
    } if (/iPad|iPhone|iPod/.test(userAgent)) {
        return PLATFORM_TYPE.IOS;
    }
    return PLATFORM_TYPE.WEB;

};

const appStore = () => {
    const platform = checkPlatform()
    if (platform === PLATFORM_TYPE.ANDROID) {
        window.location.href = APP_URLS.ANDROID

    } if (platform === PLATFORM_TYPE.IOS) {
        window.location.href = APP_URLS.IOS

    }
}
const checkOnlineStatus = async (): Promise<boolean> => {
    try {
        const online = await getObjectCommand(PING_BUCKETNAME, PING_FILE_NAME)
        if (online)
            return true
        return false
    } catch (err) {
        return false;
    }
};

export { isStandaloneMode, appStore, checkOnlineStatus };
